export enum RoomPanel {
	NONE = 'none',
	MEMBERS = 'members',
	THREAD = 'thread'
}
